import margins from "./margins";
import paddings from "./paddings";

export default { ...margins, ...paddings };

export const keys = Object.keys({ ...margins, ...paddings });
